import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum'

export default {
  Title: 'Reports',

  ReportsNotify: {
    Title: 'Reports History',
    Table: {
      Headers: {
        Id        : '#',
        Type      : 'Type',
        Range     : 'Period',
        Properties: 'Filters',
        User      : 'User',
        Notify    : 'Action',
        Download  : 'File',
        CreatedAt : 'Date',
        Actions   : ''
      }
    },

    ConfirmDeleteDialog: {
      Title  : 'Delete Report?',
      Content: 'Are you sure you want to delete report #{id}"?',
      Warning: 'The deletion is permanent and the process is irreversible.'
    },

    Type: {
      orders: {
        Title     : 'Sales Order Report',
        TitleColor: 'blue--text',
        Subtitle  : 'Send by Email'
      },
      orders_print: {
        Title     : 'Sales Order Report',
        TitleColor: 'blue--text',
        Subtitle  : 'Print'
      },
      orders_download: {
        Title     : 'Sales Order Report',
        TitleColor: 'blue--text',
        Subtitle  : 'Download'
      },

      receipts: {
        Title     : 'Sales Fiscal Doc Report (Z)',
        TitleColor: 'orange--text',
        Subtitle  : 'Send by Email'
      },
      receipts_print: {
        Title     : 'Sales Fiscal Doc Report (Z)',
        TitleColor: 'orange--text',
        Subtitle  : 'Print'
      },
      receipts_download: {
        Title     : 'Sales Fiscal Doc Report (Z)',
        TitleColor: 'orange--text',
        Subtitle  : 'Download'
      },

      sales_report: {
        Title     : 'Sales Report',
        TitleColor: 'teal--text',
        Subtitle  : 'Send by Email'
      },

      fiscal_documents: {
        Title     : 'Fiscal Documents',
        TitleColor: 'cyan--text',
        Subtitle  : 'Send by Email'
      },

      transactions: {
        Title     : 'EFT/POS Transactions',
        TitleColor: 'purple--text',
        Subtitle  : 'Send by Email'
      },

      statistics_products: {
        Title     : 'Product Statistics',
        TitleColor: 'green--text',
        Subtitle  : 'Send by Email'
      },
      statistics_products_download: {
        Title     : 'Product Statistics',
        TitleColor: 'green--text',
        Subtitle  : 'Download'
      },
      statistics_products_print: {
        Title     : 'Product Statistics',
        TitleColor: 'green--text',
        Subtitle  : 'Print'
      },

      products: {
        Title     : 'Catalog Products',
        TitleColor: 'blue-grey--text text--lighten-1',
        Subtitle  : 'Send by Email'
      },

      categories: {
        Title     : 'Catalog Categories',
        TitleColor: 'brown--text text--lighten-1',
        Subtitle  : 'Send by Email'
      }
    },

    Filter: {
      filterType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Type',
        PlaceHolder: 'All types',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Desc',
        Items      : [
          {
            Id    : 'orders_all',
            Name  : 'Sales Order Report',
            Desc  : 'All Types',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'orders_print',
            Name  : 'Sales Order Report',
            Desc  : 'Print',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'orders',
            Name  : 'Sales Order Report',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'orders_download',
            Name  : 'Sales Order Report',
            Desc  : 'Download',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'receipts_all',
            Name  : 'Sales Fiscal Doc Report (Z)',
            Desc  : 'All Types',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'receipts_print',
            Name  : 'Sales Fiscal Doc Report (Z)',
            Desc  : 'Print',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'receipts',
            Name  : 'Sales Fiscal Doc Report (Z)',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'receipts_download',
            Name  : 'Sales Fiscal Doc Report (Z)',
            Desc  : 'Download',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'sales_report',
            Name  : 'Sales Report',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'teal',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'fiscal_documents',
            Name  : 'Fiscal Documents',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'cyan',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'transactions',
            Name  : 'EFT/POS Transactions',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'purple',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'statistics_products',
            Name  : 'Product Statistics',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'products',
            Name  : 'Catalog Products',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'blue-grey lighten-1',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'categories',
            Name  : 'Catalog Categories',
            Desc  : 'Send by Email',
            Avatar: {
              Color: 'brown lighten-1',
              Icon : 'mdi-file-chart-outline'
            }
          }
        ]
      },

      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'User',
        PlaceHolder: 'All users',
        ItemText   : 'FullName',
        ItemValue  : 'Id',
        Items      : []
      },

      filterDate: {
        Type       : 'v-date-picker',
        Label      : 'Date',
        PlaceHolder: 'Select Date',
        Icon       : 'event'
      }
    }
  },

  SalesReportReceiptsZ: {
    Title: 'Sales Fiscal Doc Report (Z)',
    Table: {
      Headers: {
        Source     : 'Source',
        Order      : 'Order',
        Receipt    : 'Fiscal Doc',
        ReceiptType: 'Fiscal Doc Type',
        Total      : 'Total',
        Date       : 'Date'
      }
    },

    Export: {
      Title         : 'Export',
      Icon          : 'file_download',
      Color         : 'primary',
      SuccessMessage: 'Soon you\'ll receive the report at the email(s) you selected.'
    },

    Filter: {
      filterOrderType: {
        Type       : 'v-btn-toggle',
        Label      : 'Orders',
        PlaceHolder: 'All Orders',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'All'
          },
          {
            Value: 1,
            Name : 'With Receipt',
            Icon : 'mdi-receipt-text',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Without Receipt',
            Icon : 'mdi-receipt-text-remove',
            Color: 'orange',
            Class: 'white--text'
          }
        ]
      },

      filterInvoiceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Fiscal Doc Type',
        PlaceHolder: 'All fiscal doc types',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : [
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE,
            Name  : 'Sales Invoice',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1,
            Name  : 'Credit Invoice / Associated',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2,
            Name  : 'Credit Invoice / Not Associated',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT,
            Name  : 'Retail Receipt',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT,
            Name  : 'Services Receipt',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT,
            Name  : 'Credit Retail Receipt',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER,
            Name  : 'Order Report',
            Avatar: {
              Color: 'blue-grey',
              Icon : 'mdi-receipt-text'
            }
          }
        ]
      },

      filterSourceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Source Type',
        PlaceHolder: 'All Source Types',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : []
      }
    }
  }
}
